export default __webpack_public_path__ + "static/media/childwithcat.02dd86bf.jpg";